window.WelcomeBanner = function() {
	return {
		state: {
			plotObj: null,
			plotData: [
				{
					label: "",
					data:[
						[0,"52.27"],[1,"55.96"],[2,"53.62"],[3,"53.83"],[4,"45.18"],[5,"45.95"],[6,"44.8"],[7,"40.98"],[8,"40.18"],[9,"44.9"],[10,"47.07"],[11,"43.48"],[12,"42.0"],[13,"40.66"],[14,"40.11"],[15,"39.25"],[16,"39.61"],[17,"43.42"],[18,"44.2"],[19,"44.04"],[20,"45.84"],[21,"43.7"],[22,"43.32"],[23,"43.12"],[24,"47.84"],[25,"48.66"],[26,"45.91"],[27,"43.3"],[28,"36.01"],[29,"32.96"],[30,"26.77"],[31,"25.53"],[32,"28.58"],[33,"29.62"],[34,"27.6"],[35,"26.8"],[36,"26.54"],[37,"28.36"],[38,"30.72"],[39,"30.81"],[40,"30.12"],[41,"31.78"],[42,"37.5"],[43,"35.34"],[44,"30.38"],[45,"28.2"],[46,"27.37"],[47,"30.51"],[48,"31.29"],[49,"29.91"],[50,"28.83"],[51,"30.43"],[52,"31.98"],[53,"32.33"],[54,"30.56"],[55,"30.07"],[56,"30.3"],[57,"24.78"],[58,"25.25"],[59,"29.59"],[60,"24.96"],[61,"24.48"],[62,"24.97"],[63,"22.15"],[64,"21.54"],[65,"23.51"],[66,"22.89"],[67,"22.44"],[68,"23.78"],[69,"21.06"],[70,"20.27"],[71,"20.08"],[72,"19.78"],[73,"19.06"],[74,"20.09"],[75,"22.46"],[76,"23.17"],[77,"22.01"],[78,"27.18"],[79,"27.26"],[80,"25.29"],[81,"21.22"],[82,"16.73"],[83,"16.1"],[84,"15.96"],[85,"15.31"],[86,"18.58"],[87,"18.14"],[88,"20.14"],[89,"18.99"],[90,"19.53"],[91,"21.77"],[92,"28.34"],[93,"29.17"],[94,"26.94"],[95,"28.04"],[96,"27.79"],[97,"25.39"],[98,"27.24"],[99,"28.09"],[100,"26.31"],[101,"27.14"],[102,"29.67"],[103,"30.76"],[104,"29.43"],[105,"28.39"],[106,"25.42"],[107,"26.15"],[108,"25.42"],[109,"24.7"],[110,"22.97"],[111,"23.35"],[112,"23.18"],[113,"22.73"],[114,"18.52"],[115,"14.92"],[116,"14.13"],[117,"13.84"],[118,"14.11"],[119,"13.54"],[120,"13.51"],[121,"15.54"],[122,"15.72"],[123,"14.91"],[124,"13.52"],[125,"13.55"],[126,"13.29"],[127,"13.43"],[128,"12.9"],[129,"12.22"],[130,"10.77"],[131,"10.96"],[132,"11.24"],[133,"11.44"],[134,"11.28"],[135,"11.19"],[136,"10.77"],[137,"10.03"],[138,"9.4"],[139,"9.23"],[140,"9.82"],[141,"10.29"],[142,"13.21"],[143,"13.34"],[144,"14.6"],[145,"14.85"],[146,"14.34"],[147,"13.96"],[148,"14.69"],[149,"17.95"],[150,"18.09"],[151,"16.39"],[152,"15.39"],[153,"14.04"],[154,"13.87"],[155,"14.51"],[156,"14.77"],[157,"14.19"],[158,"14.14"],[159,"14.08"],[160,"13.24"],[161,"12.39"],[162,"10.82"],[163,"10.05"],[164,"10.54"],[165,"11.93"],[166,"13.44"],[167,"13.21"],[168,"12.67"],[169,"13.57"],[170,"14.84"],[171,"14.08"],[172,"12.96"],[173,"12.9"],[174,"12.15"],[175,"11.75"],[176,"11.83"],[177,"11.83"],[178,"12.54"],[179,"13.17"],[180,"13.48"],[181,"13.89"],[182,"14.38"],[183,"14.66"],[184,"14.82"],[185,"15.27"],[186,"14.55"],[187,"14.5"],[188,"16.09"],[189,"16.5"],[190,"16.81"],[191,"16.51"],[192,"17.52"],[193,"17.03"],[194,"17.55"],[195,"18.08"],[196,"17.98"]
					],
					lines: {
						lineWidth: 0,
						fill: 1,
						show: true
					}
				},
				{
					label: "",
					data:[
						[0,"28.94"],[1,"28.56"],[2,"29.12"],[3,"30.37"],[4,"26.67"],[5,"25.92"],[6,"22.45"],[7,"20.66"],[8,"22.28"],[9,"22.57"],[10,"23.91"],[11,"23.45"],[12,"22.57"],[13,"20.83"],[14,"20.69"],[15,"21.05"],[16,"21.88"],[17,"24.55"],[18,"24.53"],[19,"24.0"],[20,"23.55"],[21,"23.95"],[22,"26.69"],[23,"27.63"],[24,"27.26"],[25,"27.34"],[26,"26.35"],[27,"25.93"],[28,"22.57"],[29,"21.65"],[30,"19.9"],[31,"18.89"],[32,"20.75"],[33,"20.36"],[34,"18.9"],[35,"18.11"],[36,"17.91"],[37,"18.45"],[38,"19.65"],[39,"18.25"],[40,"17.38"],[41,"18.44"],[42,"19.42"],[43,"18.18"],[44,"17.22"],[45,"17.04"],[46,"17.43"],[47,"19.9"],[48,"25.0"],[49,"22.87"],[50,"36.0"],[51,"35.64"],[52,"35.02"],[53,"31.42"],[54,"31.63"],[55,"32.76"],[56,"34.16"],[57,"35.14"],[58,"35.27"],[59,"36.39"],[60,"36.7"],[61,"36.48"],[62,"31.38"],[63,"32.67"],[64,"31.67"],[65,"39.91"],[66,"44.05"],[67,"45.44"],[68,"43.53"],[69,"42.84"],[70,"44.56"],[71,"45.11"],[72,"46.33"],[73,"45.69"],[74,"42.38"],[75,"43.26"],[76,"43.15"],[77,"40.95"],[78,"40.0"],[79,"40.9"],[80,"39.09"],[81,"35.6"],[82,"32.93"],[83,"32.27"],[84,"32.24"],[85,"33.07"],[86,"35.42"],[87,"37.03"],[88,"40.51"],[89,"39.54"],[90,"43.74"],[91,"50.44"],[92,"49.99"],[93,"49.98"],[94,"52.7"],[95,"59.23"],[96,"58.02"],[97,"54.43"],[98,"54.87"],[99,"55.88"],[100,"48.86"],[101,"47.49"],[102,"46.97"],[103,"51.56"],[104,"48.54"],[105,"47.42"],[106,"45.12"],[107,"47.02"],[108,"46.21"],[109,"45.88"],[110,"48.49"],[111,"48.84"],[112,"44.93"],[113,"43.25"],[114,"39.95"],[115,"40.44"],[116,"45.6"],[117,"45.63"],[118,"46.94"],[119,"45.63"],[120,"47.14"],[121,"51.28"],[122,"51.96"],[123,"48.79"],[124,"48.78"],[125,"47.12"],[126,"46.1"],[127,"40.0"],[128,"39.51"],[129,"37.6"],[130,"37.5"],[131,"38.35"],[132,"38.78"],[133,"41.79"],[134,"37.09"],[135,"41.13"],[136,"41.25"],[137,"41.1"],[138,"41.66"],[139,"34.35"],[140,"34.18"],[141,"34.16"],[142,"34.93"],[143,"39.24"],[144,"41.39"],[145,"40.33"],[146,"43.23"],[147,"49.67"],[148,"51.83"],[149,"52.11"],[150,"49.78"],[151,"46.88"],[152,"45.96"],[153,"43.03"],[154,"44.01"],[155,"45.44"],[156,"44.99"],[157,"46.19"],[158,"47.26"],[159,"44.18"],[160,"42.89"],[161,"42.48"],[162,"42.38"],[163,"40.32"],[164,"39.57"],[165,"43.22"],[166,"46.97"],[167,"53.57"],[168,"49.72"],[169,"53.13"],[170,"54.88"],[171,"51.42"],[172,"48.39"],[173,"49.55"],[174,"50.9"],[175,"55.56"],[176,"62.13"],[177,"64.93"],[178,"61.01"],[179,"62.93"],[180,"66.37"],[181,"68.89"],[182,"67.97"],[183,"65.84"],[184,"73.18"],[185,"75.45"],[186,"85.14"],[187,"80.87"],[188,"78.67"],[189,"75.05"],[190,"72.54"],[191,"74.42"],[192,"78.61"],[193,"80.48"],[194,"84.2"],[195,"88.6"],[196,"95.8"]
					],
					bars: {
						lineWidth: 0,
				        barWidth: 0.5,
						fill: 0.5,
						align: "center",
				        show: true
				    },
					yaxis: 2
				}
			]
		},
		setState: function(state) {
			for (var key in state) {
				if (!this.state.hasOwnProperty(key)) {
					continue;
				}

				this.state[key] = state[key];
				switch (key) {
					case "plotObj":
						break;
					default:

				}
			}
		},
		el: $(".welcome-banner"),
		renderPlot: function() {
			if (this.state.plot == null) {
				var obj = this.state.plotData;

				var plotObj = this.el.find(".welcome-banner-plot");
				this.setState({plotObj: $.plot(plotObj, this.state.plotData,{
						series	:{
							shadowSize: 0,
						},
						colors	:["#fff", "#fff"],
						grid	:{
							show: false
						},
						legend	: {
							show: false
						},
						xaxis	:{
							show: false
						},
						yaxes	:[
							{
								show: false,
								max: 90
							},
							{
								show: false
							}
						]
					})
				});

				plotObj.resize();
			}
		},
		init: function() {
			this.renderPlot();
		}
	}
}
